var _rect, _rect2, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorRails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.93,
    y: 7.64,
    width: 26.141,
    height: 4.257
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.93,
    y: 15.128,
    width: 26.141,
    height: 4.257
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.93,
    y: 22.615,
    width: 26.141,
    height: 4.257
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.93,
    y: 30.103,
    width: 26.141,
    height: 4.257
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.28,
    y1: 34.36,
    x2: 12.28,
    y2: 38.399
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.28,
    y1: 26.872,
    x2: 12.28,
    y2: 30.103
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12.28,
    y1: 19.385,
    x2: 12.28,
    y2: 22.615
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12.28,
    y1: 11.897,
    x2: 12.28,
    y2: 15.128
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12.28,
    y1: 3.601,
    x2: 12.28,
    y2: 7.64
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 29.72,
    y1: 34.36,
    x2: 29.72,
    y2: 38.399
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 29.72,
    y1: 26.872,
    x2: 29.72,
    y2: 30.103
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 29.72,
    y1: 19.385,
    x2: 29.72,
    y2: 22.615
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 29.72,
    y1: 11.897,
    x2: 29.72,
    y2: 15.128
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 29.72,
    y1: 3.601,
    x2: 29.72,
    y2: 7.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorRails);
export default __webpack_public_path__ + "static/media/indoor-rails.7291a5324c3b85776ec19ff719982377.svg";
export { ForwardRef as ReactComponent };